// import {
//   login, logout, getInfo, permissonGet 
// } from '@/user'

// /account/login  post
// /permisson/get  post
// /sso/logout   get
// /permisson/getUserInfo  get

import $http from '@/utils/request'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  adminPosition: '',
  adminId:0,
  adminName: '',
  departmentId: 0,
  departmentName:'',
  userPhone:'',
  icon:'',
  permissions:null,
  logonTemCode: '',
  unreadMessageCount: 0, // 未读消息数量
  provider: null // 全局provider信息
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_ADMIN_POSITION: (state, position) => {
    state.adminPosition = position;
  },
  SET_ADMIN_ID: (state, uid) => {
    state.adminId = uid
  },
  SET_ADMIN_NAME: (state, name) => {
    state.adminName = name
  },
  SET_DEPARTMENT_ID: (state, dID) => {
    state.departmentId = dID
  },
  SET_DEPARTMENT_NAME: (state, dName) => {
    state.departmentName = dName
  },
  SET_USER_PHONE: (state, phone) => {
    state.userPhone = phone;
  },
  SET_USER_ICON: (state, icon) => {
    state.icon = icon;
  },
  SET_USER_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions;
  },
  SET_LOGIN_TEMP_CODE:(state, code) => {
    state.logonTemCode = code;
  },
  SET_UNREAD_MESSAGE_COUNT: (state, count) => {
    state.unreadMessageCount = count;
  },
  SET_ALL_INFO: (state, provider) => {
    state.provider = provider;
  }
}

const actions = {
  //登录
  login({ commit }, userInfo) {
    let { password, phone } = userInfo
    phone = phone.trim().replace(/\s+/g, '')
    return new Promise((resolve, reject) => {
      $http.post('/api/auth/account/login', {
        userphone: phone,
        password: password,
        "appCode":"srm",
        "isVerifyCode":false,
        "platformId":1
      }).then((response) => {
        const { data } = response
        commit('SET_TOKEN', data)
        setToken(data) 
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  //获取用户信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      const options = {baseURL: ''}
      $http.get('/api/srm/app/providerUser/current', state.token, options).then(({ data, code, msg })=> {
        if (code != 200) {  
          reject({ code,msg }) 
        }
        const {
          name , providerName, provider 
          ,icon,providerId
        } = data;   
        commit('SET_ROLES', ['admin'])
        commit('SET_AVATAR', '')    
        commit('SET_NAME', name)
        commit('SET_INTRODUCTION', '')
        commit('SET_ADMIN_ID', providerId)
        commit('SET_ADMIN_NAME', providerName)
        commit('SET_TOKEN', state.token)
        commit('SET_DEPARTMENT_ID', providerName)
        commit('SET_USER_ICON',icon)  
        commit('SET_ALL_INFO', provider)
        
        const newData = {
          roles: ['admin'],
          introduction: 'I am a super administrator',
          avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
          name: 'Super Admin',
          token: state.token,
        }
        resolve(newData,{ uid: providerId })
      }).catch(error => {
        reject(error)
      })
    }) 
  },

   //获取登录用户菜单权限
   getParameters({ commit, state }) {
    return new Promise((resolve, reject) => {
      $http.post('/api/auth/permisson/get', {
        appCode: 'xm-qms',
        menuId: 0
      }).then(({ data })=> {
        commit('SET_USER_PERMISSIONS', data) 
        resolve({}) 
      }).catch(error => {
        reject(error)
      })
    }) 
  }, 

  // 退出登录
  logout({ commit, state, dispatch }) {
    console.log('退出登录')
    return new Promise((resolve, reject) => {
      // $http.get('/api/auth/sso/logout').then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_USER_PERMISSIONS',null)
        removeToken()
        resetRouter()
        // dispatch('tagsView/delAllViews', null, { root: true })
        resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // 移除token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resetRouter()
      resolve()
    })
  },

  ///钉钉登录设置token
  setLoginToken({ commit }, token) {
    return new Promise(resolve => {
      commit('SET_TOKEN', token); setToken(token);
      resolve()
    })
  },

  ///设置钉钉临时登录code
  setDingTalkCode({ commit }, tempCode) {
    return new Promise(resolve => {
      commit('SET_LOGIN_TEMP_CODE', tempCode);
      resolve()
    })
  },
  ///删除钉钉临时登录code
  removeDingTalkCode({ commit }) {
    return new Promise(resolve => {
      commit('SET_LOGIN_TEMP_CODE', '');
      resolve()
    })
  },

  // 获取未读消息数量
  getUnreadMessageCount({ commit, state }) {
    return new Promise((resolve, reject) => {
      // 这里我们假设未读消息数量是消息列表的总数量
      // 在实际项目中，你可能需要调用专门的接口来获取未读消息数量
      $http.get('/api/srm/app/messageProvider/noReadCount').then(({ data }) => {
        data = data || 0
        commit('SET_UNREAD_MESSAGE_COUNT', data);
        resolve(data);
      }).catch(error => {
        console.error('获取未读消息数量失败:', error);
        commit('SET_UNREAD_MESSAGE_COUNT', 0);
        reject(error);
      });
    });
  },

  // 设置未读消息数量
  setUnreadMessageCount({ commit }, count) {
    commit('SET_UNREAD_MESSAGE_COUNT', count);
  },

  // 动态修改权限
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token' 
    commit('SET_TOKEN', token)
    setToken(token) 
    const { roles } = await dispatch('getInfo') 
    resetRouter()  
    const accessRoutes = await dispatch('/api/auth/permission/generateRoutes', roles, { root: true }) 
    router.addRoutes(accessRoutes) 
    dispatch('tagsView/delAllViews', null, { root: true })
  }
}

const getters = {
  provider: state => state.provider
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

